import React, { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { contactPhoneImage } from 'assets/images';
import { postConnectUs } from 'store/connectUs/actionCreators';
import { connectUsSelectors } from 'store/connectUs/selectors';
import {
  Input,
  Button,
  toastSuccess,
} from 'components';

import styles from './styles.module.scss';

export const ContactUsContainer = memo(() => {
  const { t } = useTranslation('welcome');
  const dispatch = useDispatch();

  const isLoading = useSelector(connectUsSelectors.getProp('isLoading'));

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [theme, setTheme] = useState('');
  const [message, setMessage] = useState('');

  const onChangeName = useCallback((str: string) => {
    setName(str);
  }, [setName]);

  const onChangeEmail = useCallback((str: string) => {
    setEmail(str);
  }, [setEmail]);

  const onChangeTheme = useCallback((str: string) => {
    setTheme(str);
  }, [setTheme]);

  const onChangeMessage = useCallback((str: string) => {
    setMessage(str);
  }, [setMessage]);

  const onSuccessCallback = useCallback(() => {
    onChangeName('');
    onChangeEmail('');
    onChangeTheme('');
    onChangeMessage('');
    toastSuccess(t('Contact_form_end_'));
  }, [
    onChangeName,
    onChangeEmail,
    onChangeTheme,
    onChangeMessage,
    t,
  ]);

  const onSubmitForm = useCallback(() => {
    dispatch(postConnectUs({
      name,
      email,
      theme,
      message,
      onSuccessCallback,
    }));
  }, [
    dispatch,
    name,
    email,
    theme,
    message,
    onSuccessCallback,
  ]);

  return (
    <div
      id="connect-with-us"
      className={styles.contact_page_container}
    >
      <p>{t('Contact_title_')}</p>

      <div className={styles.contact_container}>
        <div className={styles.contact_container_left}>
          <p>{t('Contact_subtitle_')}</p>
          <form className={styles.contact_form}>
            <div className={styles.contact_form_halfs}>
              <Input
                value={name}
                onChangeValue={onChangeName}
                placeholder={t('Contact_title_')}
              />
              <Input
                value={email}
                onChangeValue={onChangeEmail}
                placeholder={t('Contact_form_email_')}
              />
            </div>
            <Input
              value={theme}
              onChangeValue={onChangeTheme}
              placeholder={t('Contact_form_theme_')}
            />
            <Input
              value={message}
              onChangeValue={onChangeMessage}
              placeholder={t('Contact_form_message_')}
              isTextarea
              rows={5}
            />
            <a
              href="https://eclipse.club/docs/personal"
              target="_blank"
              rel="noreferrer"
            >
              {t('Contact_form_subtitle_')}
            </a>
            <Button
              onClick={onSubmitForm}
              className={styles.form_btn}
              isLoading={isLoading}
              isFullWidth
              color="pink"
            >
              {t('Contact_form_send_')}
            </Button>
          </form>
        </div>
        <img
          alt=""
          src={contactPhoneImage}
          loading="lazy"
        />
      </div>
    </div>
  );
});
